import React, { createContext, useEffect, useRef, useState } from "react";
import { verifyAuth } from "../controllers/accounts/auth";
import { getSingleAccount } from "../controllers/accounts/accounts";

const UserContext = createContext(undefined);
const UserDispatchContext = createContext(undefined);

function readLocalStorage() {
  const savedToken = localStorage.getItem('token') || ''
  try {
    const saved = localStorage.getItem('user')
    const parsedUser = saved ? JSON.parse(saved) : {}
    return { token: savedToken, ...parsedUser }
  } catch {
    return { token: savedToken }
  }
}

function UserProvider({ children }) {
  const [userDetails, setUserDetails] = useState(readLocalStorage)

  // When we have a token but no id yet, fetch the profile once in the background
  const fetchedRef = useRef(false)
  useEffect(() => {
    if (!userDetails?.token || userDetails?.id || fetchedRef.current) return
    fetchedRef.current = true
    const load = async () => {
      try {
        const verified = await verifyAuth(userDetails.token)
        if (!verified?.id) return
        let userAccount = {}
        let userMastodon = {}
        try {
          const result = await getSingleAccount(verified.id, userDetails.token)
          userAccount = result?.account ?? {}
          userMastodon = result?.mastodon ?? {}
        } catch {}
        const hydrated = { ...verified, ...userAccount, ...userMastodon }
        localStorage.setItem('user', JSON.stringify(hydrated))
        setUserDetails(prev => ({ ...prev, ...hydrated }))
      } catch {}
    }
    load()
  }, [userDetails?.token, userDetails?.id])

  return (
    <UserContext.Provider value={{ userDetails, setUserDetails }}>
      {children}
    </UserContext.Provider>
  );
}

export { UserProvider, UserContext, UserDispatchContext };
